import type { EnrichState } from "@/hooks/useEnrich";

import { Modal } from "./Modal";
import { Spinner } from "./states";

export function ResultModal({
  state,
  onClose,
  onFavoriteIdea,
  favPending,
}: {
  state: EnrichState;
  onClose: () => void;
  onFavoriteIdea?: (ideaIndex: number) => void;
  favPending?: boolean;
}) {
  const isSummary = state.kind === "summary";
  const title = `${isSummary ? "Суть" : "Идеи"} · ${state.fullName}`;
  const busy = state.status === "starting" || state.status === "pending" || state.status === "running";

  return (
    <Modal title={title} onClose={onClose}>
      {busy && (
        <Spinner label={isSummary ? "Haiku читает README…" : "Sonnet придумывает идеи…"} />
      )}

      {state.status === "failed" && (
        <div className="py-6 text-center text-err">
          Не удалось сгенерировать. Проверь, что в настройках задан ключ Anthropic.
        </div>
      )}

      {state.status === "done" && state.enrichment && (
        <div className="space-y-3">
          <p className="whitespace-pre-line text-sm leading-relaxed text-ink-1">
            {state.enrichment.summary}
          </p>
          {!isSummary &&
            state.enrichment.ideas.map((idea, i) => (
              <div key={i} className="rounded-lg border border-line bg-bg-0 p-3">
                <div className="flex items-start justify-between gap-2">
                  <div className="font-medium text-ink-1">
                    {idea.title}
                    {idea.difficulty && (
                      <span className="ml-2 text-xs text-ink-3">· {idea.difficulty}</span>
                    )}
                  </div>
                  {onFavoriteIdea && state.enrichment?.id != null && (
                    <button
                      type="button"
                      onClick={() => onFavoriteIdea(i)}
                      disabled={favPending}
                      title="Идею в избранное"
                      className="shrink-0 text-sm hover:scale-110 disabled:opacity-50"
                    >
                      ⭐
                    </button>
                  )}
                </div>
                {idea.mechanic && <div className="text-xs text-accent">{idea.mechanic}</div>}
                {idea.why_specific && (
                  <div className="mt-1 text-sm text-ink-2">{idea.why_specific}</div>
                )}
                {idea.combo_hint && (
                  <div className="mt-1 text-xs text-ink-3">🔗 {idea.combo_hint}</div>
                )}
              </div>
            ))}
        </div>
      )}
    </Modal>
  );
}
